<template>
  <vue-slider
    :max="preparedMax"
    :value="position"
    v-bind="options"
    class="time-slider time-position-select"
    @change="update"
  >
  </vue-slider>
</template>

<script>
import VueSlider from "vue-slider-component";
import TimeSliderMixin from "@/components/sliders/TimeSliderMixin.vue";

// @group Sliders
// Slider that contains two pointers for select some fixed range in time
export default {
  name: "TimeSlider",
  components: {
    VueSlider
  },
  mixins: [TimeSliderMixin],
  model: {
    prop: "position",
    event: "update"
  },
  props: {
    // Array of two pointer values (in seconds)
    position: {
      type: Array,
      required: true
    },
    // Maximum time (in seconds)
    max: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      options: {
        width: "100%",
        min: 0,
        interval: 0.01,
        fixed: true,
        tooltipFormatter: this.getTime,
        processStyle: {
          "background-color": "#13d413"
        },
        dotStyle: {
          width: "3px",
          "border-radius": "0",
          "background-color": "#13d413",
          "box-shadow": "none"
        }
      }
    };
  },
  computed: {
    // @vuese
    // Rounded down max time
    preparedMax() {
      return Math.floor(this.max);
    }
  },
  methods: {
    // @vuese
    // Update slider value
    update(val, idx) {
      const newPos = [...this.position];
      newPos[idx] = val;
      this.$emit("update", val);
    }
  }
};
</script>

<style scoped>
.time-slider {
  width: 100%;
}
</style>

<style>
.time-position-select .vue-slider-dot.vue-slider-dot-hover {
  width: 3px !important;
}
</style>
